import React, { MouseEvent } from "react";
import classnames from "classnames/bind";
import style from "./index.module.scss";
import { IState, ITWorkshop, LocationType, Replacement } from "../../../interface";
import analyseData from "../../../utils/analyseData";
import _ from "lodash";
import moment from "moment";
import { checkHttpAddress } from "../../../utils/validate";
import localesReplacement from "../../../utils/localesReplacement";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import actions from "../../../redux/actions";
import ClickOut from "react-click-out";
import {
  CountriesWithCustomizedWTB,
} from "../../../constants";
import { getLocationImage } from "../../../utils";

const cx = classnames.bind(style);
/* eslint-disable */
export interface IProps {
  dataList: ITWorkshop;
  selectedLocation: ITWorkshop | null;
  replacements: Replacement;
  onContactClick: (value: ITWorkshop) => void;
  onBookClick: (value: ITWorkshop) => void;
  setSelectedLocation: (value: ITWorkshop | null) => void;
  setAccord: (value: boolean) => void;
}

const regex = /<a/;

interface IAddressData {
  line1: string | null;
  townOrCity: string | null;
  postCode: string | null;
}


//Workshop detail component
function Workshop(props: IProps) {
  const {
    dataList,
    selectedLocation,
    replacements,
    setSelectedLocation,
    setAccord,
  } = props;
  const window: any = globalThis
  const setActiveLocation = (evt: MouseEvent) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'whereToBuyCardClick',
      'pageType': 'where to buy',
      'serviceType': dataList.locationTypes[0].name.toLocaleLowerCase(),
      'countryCode': localStorage.getItem('countryCode'),
      'serviceOutlet': dataList.name.toLocaleLowerCase()
    });

    setSelectedLocation(dataList);
    evt.stopPropagation();
  };
  const urlDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'whereToBuyUrlClick',
      'pageType': 'where to buy',
      'serviceType': dataList.locationTypes[0].name.toLowerCase(),
      'countryCode': localStorage.getItem('countryCode'),
      'serviceOutlet': dataList.name.toLocaleLowerCase()
    });
  }
  const bmgDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'whereToBuyUrlClick',
      'pageType': 'where to buy',
      'serviceType': 'Book My Garage',
      'countryCode': localStorage.getItem('countryCode'),
      'serviceOutlet': dataList.name.toLocaleLowerCase()
    });
  }
  const clickout = (evt: globalThis.MouseEvent) => {
    const map = document.getElementById("google-map");
    if (!map?.contains(evt.target as Node)) {
      setSelectedLocation(null);
    }
  };
  const checkAddressIsNull = (address: IAddressData) => {
    if (
      address["line1"] === null &&
      address["townOrCity"] === null &&
      address["postCode"] === null
    ) {
      return true;
    }
    return false;
  };

  const localizeLocationType = (locationTypes: LocationType[]) => {
    return locationTypes.map((item) => localesReplacement(replacements, item.name))
  }

  const handleBookNow = (url : string) => {
    bmgDataLayer();
    // TODO : possible place to trigger validation dialog box
    window.open(checkHttpAddress(url) ? url : "https://" + url);
  }

  return (
    <ClickOut className="click-out" onClickOut={(e) => clickout(e)}>
      <div
        className={cx(
          "workshop",
          {
            highlight:
              !!selectedLocation && _.isEqual(selectedLocation.id, dataList.id),
            subdued:
              !!selectedLocation &&
              !_.isEqual(selectedLocation.id, dataList.id),
          },
          "workshop-wrapper"
        )}
        onClick={(evt => {
          setActiveLocation(evt);
          setAccord(true);
        })}
      >
        <div className={cx("thumb")}>
          {/* banner */}
          <img
            src={getLocationImage(dataList)}
          />
          {dataList?.castrolCertified && (
            <span className={cx("recommendation")}>
              {localesReplacement(replacements, "Castrol Certified")}
            </span>
          )}
        </div>
        {/* workshop information */}
        <div className={cx("content")}>
          <div className={cx("heading")}>
            <h4>{dataList["name"]}</h4>
          </div>
          <ul>
            {!checkAddressIsNull(dataList["address"]) && (
              <li className={cx("address")}>
                <span className=
"overflowText"
>
  {dataList[
"address"
][
"line1"
]}
  {dataList[
"address"
][
"line1"
] &&
", "
}
  {dataList[
"address"
][
"townOrCity"
]}
  {dataList[
"address"
][
"townOrCity"
] &&
", "
}
  {dataList[
"address"
][
"county"
]}
  {dataList[
"address"
][
"county"
] &&
", "
}
  {dataList[
"address"
][
"postCode"
]}
</span>
              </li>
            )}

            {dataList["telephone"] && (
              <li className={cx("phone")}>
                <span className="overflowText">{dataList["telephone"]}</span>
              </li>
            )}
            {dataList["email"] && (
              <li className={cx("email")}>
                <span className="overflowText">{dataList["email"]}</span>
              </li>
            )}
            {!_.isEmpty(
              _.flatMap(dataList["openingHours"], (item) => {
                return _.compact(_.values(_.pick(item, "open", "close")));
              })
            ) && (
                <li className={cx("time")}>
                  <div className={cx("list")}>
                    {_.map(_.sortBy(dataList["openingHours"], 'isoWeekday'), (item, index) =>
                      !!item["open"] && !!item["close"] ? (
                        <div key={index} className={cx("item")}>
                          <span>
                            {localesReplacement(replacements, moment.weekdaysShort(item["isoWeekday"]))}:
                          </span>
                          {localesReplacement(replacements, "Opens from")}{" "}
                          {item["open"]
                            ? analyseData.hourFormat(item["open"])
                            : ""}{" "}
                          -{" "}
                          {item["close"]
                            ? analyseData.hourFormat(item["close"])
                            : ""}
                        </div>
                      ) : null
                    )}
                  </div>
                </li>
              )}
            {dataList["website"]?.match(regex) ? (
              <li className={cx("website")}>
                <div dangerouslySetInnerHTML={{ __html: dataList['website'] }} />
              </li>
            ) : dataList["website"] && (
              <li className={cx("website")}>
                <a
                  onClick={urlDataLayer}
                  className="overflowText"
                  target="_blank"
                  rel="noreferrer"
                  href={checkHttpAddress(dataList["website"]) ? dataList["website"] : "https://" + dataList["website"]}
                >
                  {dataList["website"]}
                </a>
              </li>
            )}

            {/* 6333728: Book My Garage */}
            {/* {dataList["bmgWebsite"]?.match(regex) ? (
              <li className={cx("website")}>
                <div dangerouslySetInnerHTML={{ __html: dataList['bmgWebsite'] }} />
              </li>
            ) : dataList["bmgWebsite"] && (
              <li className={cx("website")}>
                <a
                  onClick={bmgDataLayer}
                  className="overflowText"
                  target="_blank"
                  rel="noreferrer"
                  href={checkHttpAddress(dataList["bmgWebsite"]) ? dataList["bmgWebsite"] : "https://" + dataList["bmgWebsite"]}
                >
                  {localesReplacement(replacements, "Book Now (Redirects to external site)")}
                </a>
              </li>
            )} */}
            
          </ul>
          {/* 3746334 */}
          {!CountriesWithCustomizedWTB.includes(localStorage.countryCode) && (
            <dl>
              <dt>{localesReplacement(replacements, "Location type")}: </dt>
              <dd className="overflowText">
                {localesReplacement(replacements, _.join(localizeLocationType(dataList["locationTypes"])))}
              </dd>
            </dl>
          )}
          {/* 6333728: Book My Garage */}
          {dataList["bmgWebsite"]?.match(regex) ? (
              <li className={cx("website")}>
                <div dangerouslySetInnerHTML={{ __html: dataList['bmgWebsite'] }} />
              </li>
            ) : dataList["bmgWebsite"] && (
              <div className={cx("button-container")}>
                <button className={cx("book-now-button")} 
                onClick={ () => handleBookNow(dataList["bmgWebsite"])}
                >
                  {localesReplacement(replacements,'Book Now')}
                </button>
              </div>
            )}
        </div>
      </div>
    </ClickOut>
  );
}

const mapStateToProps = (state: IState) => ({
  selectedLocation: state.selectedLocation,
  replacements: state.replacements,
  country: state.country,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSelectedLocation: (value: ITWorkshop | null) =>
    dispatch(actions.setSelectedLocation(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Workshop);
